export default {
  logging: {
    SET_CONTEXT: 'SET_CONTEXT',
    LOG_ERROR: 'LOG_ERROR'
  }
};